export const getHeaderTitle = (data): any => {
    const { isCollectors, isMuseums, isDealersStock, isWineSpirits, isCommercialProperty } = data
    if (isCollectors) return 'Collections Policy'
    if (isMuseums) return 'Museums Policy'
    if (isDealersStock) return 'Dealers Stock'
    if (isWineSpirits) return 'Wine & Spirits Policy'
    if (isCommercialProperty) return 'Commercial Property'
    return 'Commercial Art Insurance'
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/List.tsx